/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailContainer
 */
export interface EmailContainer {
    /**
     * 
     * @type {string}
     * @memberof EmailContainer
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailContainer
     */
    content: string;
}

/**
 * Check if a given object implements the EmailContainer interface.
 */
export function instanceOfEmailContainer(value: object): value is EmailContainer {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function EmailContainerFromJSON(json: any): EmailContainer {
    return EmailContainerFromJSONTyped(json, false);
}

export function EmailContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailContainer {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function EmailContainerToJSON(json: any): EmailContainer {
    return EmailContainerToJSONTyped(json, false);
}

export function EmailContainerToJSONTyped(value?: EmailContainer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'content': value['content'],
    };
}

